import React from 'react';
import { PAYMENTS } from 'state/payment/type';
import { cn } from 'lib/utils';

interface props {
  info: PAYMENTS.IIndividualTransactionResult;
}

const PaymentMethod = ({
  info = {} as PAYMENTS.IIndividualTransactionResult,
}: props): JSX.Element => {
  return (
    <>
      <div className="mb-9 pb-2">
        <h3 className="mb-2 PaymentDetailsHeading">Payment method</h3>
        <hr className="mt-0 pb-1 mb-2" />
        <div>
          <div className="py-1 pt-0">
            <span className="text-gray-blue-50 text-sm leading-5 font-normal mr-4 min-w-[191px] max-w-[240px] inline-block">
              Method
            </span>
            <span className="text-gray-blue-80 text-sm leading-5 font-normal">
              {info.payment_type}
            </span>
          </div>
          <div className="py-1">
            <span className="text-gray-blue-50 text-sm leading-5 font-normal mr-4 min-w-[191px] max-w-[240px] inline-block">
              Card Issuer / Bank / Wallet
            </span>
            <span className="text-gray-blue-80 text-sm leading-5 font-normal">
              {info.consumer_bank_name || 'na'}
            </span>
          </div>
          <div className="py-1 pb-0">
            <span className="text-gray-blue-50 text-sm leading-5 font-normal mr-4 min-w-[191px] max-w-[240px] inline-block">
              Account / Card Number
            </span>
            <span className="text-gray-blue-80 text-sm leading-5 font-normal">
              {info.consumer_account}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentMethod;
